<template>
  <div>
    <div v-if="teams && teams.length">
      <h1 class="display-1 text-center">NBA Teams</h1>
      <v-autocomplete
        label="Select a Team"
        :items="teams.map((t) => t.full_name)"
        @change="selectTeam"
      ></v-autocomplete>
      <TeamInfo :team="currentTeam" :roster="roster" />
    </div>
    <div v-else-if="!error && !teams" class="text-center">
      <v-progress-circular value="Loading Teams" size="400" indeterminate color="blue darken-3"></v-progress-circular>
    </div>
    <ErrorMessage v-if="error" message="Error fetching NBA teams! Check backend!" />
  </div>
</template>

<script>
import config from "@/config";
import ErrorMessage from "@/components/ErrorMessage.vue";
import TeamInfo from "@/components/TeamInfo.vue";

export default {
  name: "Teams",
  components: {
    ErrorMessage,
    TeamInfo
  },
  data() {
    return {
      teams: null,
      currentTeam: null,
      roster: [],
      error: false
    };
  },
  async mounted() {
    try {
      const res = await fetch(config.API + "teams/all_teams");
      const data = await res.json();

      this.teams = data;
    } catch (e) {
      this.error = true;
    }
  },
  methods: {
    async selectTeam(teamName) {
      this.currentTeam = this.teams.find(t => t.full_name === teamName);

      const rosterUrl = `${config.API}players/roster/${this.currentTeam.id}`;

      const res = await fetch(rosterUrl);
      const data = await res.json();

      this.roster = data;
    }
  }
};
</script>


<style scoped lang="scss">
.team-item {
  max-width: fit-content !important;
}
</style>